// extracted by mini-css-extract-plugin
module.exports = {"main":"middle_main__3xpnm","container":"middle_container__3umqG","xmas":"middle_xmas__3dQrS"};